module.exports = __webpack_public_path__ + "assets/b83d5678c3335f4ff855e9630c15fd5b.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/win/Level1_Hit01s.mp3
 ** module id = 334
 ** module chunks = 0
 **/